import React from "react";
import {
  FiUsers,
  FiCode,
  FiShare2,
  FiPhoneCall,
  FiShield,
  FiCheckSquare,
  FiGlobe,
  FiCloud,
  FiBarChart2,
  FiCompass,
  FiHeadphones
} from "react-icons/fi";

const map = {
  people: FiUsers,
  code: FiCode,
  network: FiShare2,
  phone: FiPhoneCall,
  shield: FiShield,
  tasks: FiCheckSquare,
  globe: FiGlobe,
  cloud: FiCloud,
  chart: FiBarChart2,
  compass: FiCompass,
  support: FiHeadphones
};

const ServiceIcon = ({ name }) => {
  const Cmp = map[name] || FiCheckSquare;
  return <Cmp />;
};

export default ServiceIcon;
